import type { AgreementRepository } from "../../domain/repositories/AgreementRepository";
import type {
  AgreementDetails,
  Agreement as AgreementEntity,
  RegistrationAgreementClause,
  RegistrationScopeFilters,
} from "../../domain/entities/Agreement";

export interface AgreementData {
  agreements: AgreementEntity[];
  details: AgreementDetails[];
}

export const getAgreements = async (
  repo: AgreementRepository,
  filters?: RegistrationScopeFilters,
): Promise<AgreementData> => {
  const agreements = await repo.getRegisterAgreementIds(filters);
  const details = await Promise.all(
    agreements.map((ag) => repo.getRegisterAgreementDetails(ag.id)),
  );
  return { agreements, details };
};

export const getRequiredRegistrationClauses = async (
  repo: AgreementRepository,
  filters?: RegistrationScopeFilters,
): Promise<RegistrationAgreementClause[]> => {
  return repo.getRequiredRegistrationClauses(filters);
};
